import React, { useState, useEffect, useRef,useMemo,useCallback } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import { Formik } from "formik";
import { Select } from "@appkit4/react-components/select";
import { TextArea } from "@appkit4/react-components/field";
import * as Yup from "yup";
  import { forwardRef } from "react";
import { Modal } from "@appkit4/react-components/modal";
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import displayToastMessage from "../../../../src/components/Common/Alert/displayToastMessage";
import { getMimetype } from "../../Common/FileValidation";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";
import PropTypes from 'prop-types'
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import download from "../../../../src/assets/images/download.svg"
import { Button } from "@appkit4/react-components/button";


export default function EditVendor(props) {
  const { SelfAssessmentData, tableDataProp,getAllInitialData,wpCategoryData,vendorComment,workProgrammeName } = props;
 
  const [manager, setManager] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [tableData, setTableData] = useState(tableDataProp);
  const [selectedType, setSelectedType] = useState(1);
  const [workProgramName, setWorkProgram] = useState([]);
  const [comments, setComments] = useState("");
  const [save, setSave] = useState(false);
  const [fileName, setFileName] = useState("");
  const [modalVisible, setmodalVisible] = useState(false);
  const [commentsFormat, setCommentsFormat] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const { sendRequest: downloadAPI } = useHttp();
  const { sendRequest: getAllControlWorkProgramAPI } = useHttp();
const[value,setValue]= useState("");
const[loader,setLoader]=useState(true);
const [paramStatus, setParamStatus] = useState("");

  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: updateSelfAssessment } = useHttp();
  const { sendRequest: saveEvidence } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: getAllManagersList } = useHttp();
  const inputRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);

   // Apply settings across all columns
   const defaultColDef = useMemo(() => ({
    // Enable filtering on all columns,
    // flex:1,
    sortable: true,
    cellDataType: false,
    wrapText: true,     
    autoHeight: true,
    resizable:true,
  }));

  const onGridReady = (params) => {
    setGridApi(params.api);
  };


  useEffect(() => {
    setTableData(tableDataProp)
    let data = {};
    if (tableDataProp.length > 0) {
      data = tableDataProp[0];
    }
    let tableType = [];
    tableType = Object.keys(data);
    if (tableDataProp && tableType.includes("Area")) {
      setSelectedType(2);
    } else {
      setSelectedType(1);
    }

    getInitialDataHandler();
    getWorkPrograms();
  }, [tableDataProp]);

  useEffect(() => {
    setInitialValues((oldValue) => {
      return { ...oldValue, 
      assessmentID: props.SelfAssessmentData[0]?.assessment_id,
      vendorName: props.SelfAssessmentData[0]?.vendor_id,
      scopeOfAssessment:
      props.SelfAssessmentData[0]?.scopeofassessment,
      manager:props.SelfAssessmentData[0]?.manager,
      respondent: props.SelfAssessmentData[0]?.vendorrespondant,
      workProgram: props.wpCategoryData[0]?.workprogramid,
      assesorComment:props.SelfAssessmentData[SelfAssessmentData.length-1]?.comments,

  }})
  }, [props.SelfAssessmentData, props.wpCategoryData])

  useEffect(() => {
    vendorComments();
  },[])
  const vendorComments=()=>{
     vendorComment.forEach(function (arrayItem) {
      if(arrayItem?.assessment_id==SelfAssessmentData[0]?.assessment_id)
      {
        setComments(SelfAssessmentData[0].vendorcomments)
      }
  });
    
  }

  const getWorkPrograms = async () => {
    await getAllControlWorkProgramAPI(
      APIService.getAllControlWorkProgram(),
      (data) => setWorkProgram(data.MSG)
    );
  };

  const responseHandler = (result) => {
    if (result.CODE) {
      setVendors(result.MSG);
    }
  };

  const errorHandler = () => {
    displayToastMessage("Something went wrong, Please try again!", "error");
  };

  const responseHandlerManager = (result) => {
    if (result.CODE) {
      setManager(result.MSG);
    }
  }

  let getInitialDataHandler = async () => {
    await getAllVendorList(APIService.getAllVendorList(), responseHandler, errorHandler)
    await getAllManagersList(APIService.getAllManagersList(), responseHandlerManager, errorHandler)
    setLoader(false);
  };

  const handleCancel = () => {
    setmodalVisible(false);
  };

  function MimeType(fileList) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(fileList[0]);
      fileReader.onload = (e) => {
        const uint = new Uint8Array(e.target.result).subarray(0, 4);
        let bytes = [];
        uint.forEach((byte) => {
          bytes.push(byte.toString(16));
        });
        const hex = bytes.join("").toUpperCase();
        resolve({ hex, files: fileList });
      };
      fileReader.onerror = reject;
    });
  }

  const changeHandler = (evt, rowData) => {
    if (evt.target.files[0].size <= 20 * 1000 * 1024) {
    MimeType(evt.target.files)
      .then((e) => {
        if (getMimetype(e.hex, e.files[0].type)) {
          rowData.data["Evidence"] = e.files[0].name;
          let newFile = {};
          newFile.name = e.files[0].name;
          newFile.fileType = e.files[0].type;
          newFile.unique_name = `${sessionStorage.getItem("userId")}_${rowData?.data?.tableData?.id
            }_${e.files[0].name}`;
          rowData.data["Evidence_File_Path"] = newFile.unique_name;
          rowData.data["Evidences"] = e.files[0].name;
          var reader = new FileReader();
          // Store relevant information from the event
          const files = e.files,
            f = files[0];
          reader.readAsDataURL(f);
          reader.onload = (evt) => {
            const bstr = evt.target.result;
            // var b64 = btoa(bstr);
            newFile.base64File = bstr;
            newFile.hex = e.hex;
            // Call fileHandleUpload inside the onload callback
            fileHandleUpload(newFile);
          };
        } else {
          let MSG = "Please upload a valid, non-empty file.";
          displayToastMessage(MSG, "error");
          evt.target = null;
        }
      })
      .catch((err) => {
        let MSG = "Something went wrong, Please try again!";
        displayToastMessage(MSG, "error");
      });
    } else {
      displayToastMessage("Size of the file should be less than 20MB", "error")
    }
  };

  const responseHandlerUpload = (result) => {
    if (result.CODE) {
      displayToastMessage(result.MSG, "success");
    }
  };

  const fileHandleUpload = async (newFile) => {
    saveEvidence(
      APIService.saveEvidence(newFile),
      responseHandlerUpload,
      errorHandler
    );
  };

  const validationSchema = Yup.object().shape({
    vendorName: Yup.string()
      .required("Third party name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    scopeOfAssessment: Yup.string()
      .required("Scope of assessment is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    workProgram: Yup.string()
      .required("Work program is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    assessmentID: Yup.number().required("Assessment ID is required"),
    manager: Yup.string()
      .required(" Third party manager is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    respondent: Yup.string()
      .required("Third party respondent is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
  });


 


  

 

  

  const handleSubmit = async () => {
    let z;
   
     if(!commentsFormat)
    {
    let jsonArray = [];
    let data = {
      email:props.SelfAssessmentData[0].assessoremail,
      vendorName:props.SelfAssessmentData[0]?.vendor_name,
      flag: "update",
      paramVendorID: props.SelfAssessmentData[0]?.vendor_id,
      paramScopeOfAssessment: props.SelfAssessmentData[0]?.scopeofassessment,
      paramVendorManager: props.SelfAssessmentData[0]?.manager,
      paramAssessmentID: props.SelfAssessmentData[0]?.assessment_id,
      paramAssessmentTypeID:
        SelfAssessmentData[0]?.assessmenttypeid,
      paramVendorRespondant: props.SelfAssessmentData[0]?.vendorrespondant,
      paramWorkProgramID: Number(props.workProgrammeName),
      paramCategoryData: JSON.stringify(tableData),
      paramUserID: Number(sessionStorage.getItem("userId")),
      paramVendorResponseStatusId: save ? "2" : "3",
      paramVendorReviewStatusId: save ? "2" : "3",
      paramAssessmentStatus: "Updated",
      paramcomments: comments,
      paramUser:sessionStorage.getItem("username"),
      paramOrganizationName: sessionStorage.getItem("org_name"),
      paramVendorEmail: sessionStorage.getItem("email")
    };
    jsonArray.push(data);
    updateSelfAssessment(
      APIService.updateSelfAssessment(jsonArray),
      responseHandlerUpdate,
      errorHandlerUpdate
    );
    }
  };

  const responseHandlerUpdate = (result) => {
    if (result.CODE) {
      // if(!save)
      //   {
      //     displayToastMessage(result.MSG, "success");

      //   }else{
      //     displayToastMessage("Assessment saved successfully", "success");

      //   }
      let notifData = {
        paramuserid: Number(sessionStorage.getItem("userId")),
        paramreqid: SelfAssessmentData && SelfAssessmentData[0].assessorid,
        paramcontent: "Updated self assessment",
        paramnextroleid: 4,
        paramcreatedby: Number(sessionStorage.getItem("roleId")),
        parammsgtype: result.MSG,
      };
      getAllInitialData();
      handleNotificationSubmitAPI(
        APIService.handleNotificationSubmit(notifData),
        () => {}
      );
      props.sendBack();
    }
  };

  const errorHandlerUpdate = () => {
    let MSG = "Something went wrong, Please try again!";
    displayToastMessage(MSG, "error");
  };

  const handleConfirm = () => {
    if (save) {
      let msg = "Request has been saved successfully";
      displayToastMessage(msg, "success");
      setmodalVisible(false);
      handleSubmit();
      props.sendBack();
    } else {
      setmodalVisible(false);
      let flag=0;
      let z=0;
      for ( z = 0; z < tableData.length; z++) {
       let keys = Object.keys(tableData[z]);
        if (!keys.includes("Third Party Response")) {
          flag=1;
          break;

      }
      }
   
      if(flag==1)
        {

          let MSG = "Please fill the vendor response field for all the questions in the assessment";
          displayToastMessage(MSG, "warning");
        }else{
          handleSubmit();
          let msg = "Request has been submitted successfully";
          displayToastMessage(msg, "success");
          props.sendBack();
        }
    }

    
  };

  const saveHandler = (param) => {
    if (!commentsFormat && param=='save') {
      setmodalVisible(true);
      setParamStatus(param);
      setSave(true);
    }else  if (!commentsFormat && param=='submit') {
      setmodalVisible(true);
      setParamStatus(param);
      setSave(false);
    }
  };

  const downloadResponseHandler = (result, fileName) => {
    if (result) {
      const blob = new Blob([result?.data], {
        type: "application/octet-stream",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      displayToastMessage("File Downloaded successfully", "success");
    }
  };

  const getDownloadFile = async (data, fileName) => {
    await downloadAPI(
      APIService.downloadFile(data),
      (res) => downloadResponseHandler(res, fileName),
      (err) => {
        let MSG = "Something went wrong, Please try again!";
        displayToastMessage(MSG, "error");
      },
      true
    );
  };

  const handleChangeComment = (e) => {
    if (e.search(/[^()0-9a-zA-Z,. ]/) === -1) {
      setCommentsFormat(false);
    } else {
      setComments();
      setCommentsFormat(true);
    }
    setComments(e);
  };

  const [colDefs1] = useState(
    [
      {
        headerName: "Domain",
        field: "Domain", pinned: 'left'
      }, {
        headerName: "Sub Domain",
        field: "Sub Domain", pinned: 'left'
      }, {
        headerName: "Control Definition",
        field: "Control Definition", pinned: 'left'
      }, {
        headerName: "Control Testing Procedure",
        field: "Control Testing Procedure", pinned: 'left'
      },      {
        headerName: "Third Party Response",
        field: "Third Party Response",
        editable: true,
        cellEditor: 'agSelectCellEditor',
        cellEditorPopup: false,
        cellEditorParams: {
            values: ['YES', 'NO','NA'],
        }
    }, {
        headerName: "Third Party Comments",
        field: "Vendor Response",
        editable: 'true',
        
      },{
        headerName: "Evidence",
        field: "Evidence",
        cellRenderer: (rowData) => {
          if(rowData?.data?.Evidence_File_Content)
          {
            return rowData?.data?.Evidence ?
            (rowData?.data?.Evidence_File_Content ?
              (
                <a href={rowData?.data?.Evidence_File_Content} download={rowData?.data?.Evidence} className="hyperText">{rowData?.data?.Evidence}</a>
              )
              : (<>{rowData?.data?.Evidence}</>))
            : (<p></p>)
          }else{
           return rowData?.data?.Evidence ?
            (rowData?.data?.Evidence_File_Path ?
              (
                <div onClick={()=>getDownloadFile(rowData?.data?.Evidence_File_Path,rowData?.data?.Evidence)} className="hyperText">{rowData?.data?.Evidence} </div>
              )
              : (<>{rowData?.data?.Evidence}</>))
            : (<p></p>)
              }
        },
      },
      { headerName: "Assessor Comments", field: "Assessor Comments ",editable:false, },
      
      {
        headerName: "Closure Status",
        field: "Closure Status",
        editable: false,
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
            values: ['Yes', 'No','NA'],
        }
      },
 
    ])
    const [colDefs2] = useState(
    [
      {
        children: [   { headerName: "ID", field: "Question Id", editable: 'never', width:"90"  },
          { headerName: "Question", field: "Question",tooltipField:"Question",flex: 1, minWidth: 400, maxWidth: 950, cellClass: 'questionToolTip'},
             { headerName: "Instructions (If any)",field: "Instructions (If any)", width: 170 }
    ]},
   { children: [
      { columnGroupShow: "open", headerName: "Area",
        field: "Area",width:"120" },
        {columnGroupShow: "open", headerName: "Sub Area", field: "Sub Area",pinned: 'left',width:"120" },
        {
          columnGroupShow: "closed",headerName: "Third Party Response*",
          field: "Third Party Response",
          editable: true,
          cellEditor: 'agSelectCellEditor',
          cellEditorPopup: false,
          cellEditorParams: {
              values: ['YES', 'NO','NA'],
          }, cellStyle: {border: '0.5px solid #dedede',textAlign: 'center'},width:"170"
      },
     
      {
        columnGroupShow: "closed",headerName: "Evidence",
        field: "Evidence",
        editable:true,
        flex:1,
        minWidth: 200,
        maxWidth: 400,
        // cellEditor: CustomEditorComp,
        cellEditor:(rowData)=>(

          rowData.data["Attachment required"] ===
          "Y" ?
         
          <div>
          <input
            type="file"
            accept=".xls,.xlsx,.pdf,.txt,.csv,.png,.jpeg,.jpg,.ppt,.pptx"
            onChange={(e) =>changeHandler(e, rowData)}
          />
      
        </div>                        
  :<p></p>
  ),
  cellRenderer: (rowData) => {

    if(rowData?.data?.Evidence_File_Content)
    {
      return rowData?.data?.Evidences ?
      (rowData?.data?.Evidence_File_Content ?
        (
          <a href={rowData?.data?.Evidence_File_Content} download={rowData?.data?.Evidences} className="hyperText">{rowData?.data?.Evidences}</a>
        )
        : (<>{rowData?.data?.Evidences}</>))
      : (<p>{rowData?.data["Attachment required"] ===
        "N"?'':                                        <img alt="edit" src={download} className="edit-input" style={{ transform: "rotate(270deg)" }} />
  }</p>)
    }else{

     return rowData?.data?.Evidences ?
      (rowData?.data?.Evidence_File_Path ?
        (
          <div onClick={()=>getDownloadFile(rowData?.data?.Evidence_File_Path,rowData?.data?.Evidences)} className="hyperText">{rowData?.data?.Evidences} </div>
        )
        : (<>{rowData?.data?.Evidences}</>))
      : (<p>{rowData?.data["Attachment required"] ===
        "Y"?<img alt="edit" src={download} className="edit-input" style={{ transform: "rotate(270deg)" }} />:''
  }</p>)
        }
  },
      }, 
      {columnGroupShow: "closed",flex: 1, minWidth: 400, maxWidth: 1050, headerName: "Third Party Comments*",tooltipField:"Vendor Response", cellStyle: {border: '0.5px solid #dedede'}, field: "Vendor Response",editable:true,cellEditor: "agLargeTextCellEditor",cellEditorPopup: true,cellEditorParams: {
        maxLength: 500
    }, valueSetter: (params) => {
        const data = params.newValue ;
     
    if(data?.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1)
        {
          displayToastMessage("Allowed special characters .:/,()", "error");
  
          return false;
      }else{
        params.data["Vendor Response"]=data;
        return true;
      }
      }
      }, 
      {
        columnGroupShow: "open", headerName: "Assessor Comments",
        field: "Assessor Comments ",
        editable: 'never',
        flex: 1,
        minWidth: 400,
        maxWidth: 1050,
        tooltipField:"Assessor Comments ",
      },
      
      {
        columnGroupShow: "open", headerName: "Closure Status",
        field: "Closure Status",
        editable: false,
        cellEditor: 'agSelectCellEditor',
        cellEditorPopup: false,
        cellEditorParams: {
            values: ['Yes', 'No','NA'],
        },
    },  
      ] 
    }
  ]);

  const defaultColGroupDef = useMemo(() => {
    return {
      headerName: "Vendor Details",
    };
  }, []);

  const onCellValueChanged = ((event) => {
    var data = event.data;
    const dataUpdate = [...tableData];
    const index = event.rowIndex;
    dataUpdate[index] = data;
    setTableData([...dataUpdate]);
  });


  const rowStyle = { background: 'white' };



  return (
    <div className="App">
      <div className="row text-end">
        <div className="col-md-12">
          <span
            className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
            onClick={props.sendBack}
          ></span>
        </div>
      </div>
      {initialValues && 
      <Formik
        initialValues={initialValues}
         onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({values,
            touched,
            errors,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting}) => {
          return (
            loader ? (
              <div className="row" id="preloader">
                <div className="col-12 col-lg-12 loader-margin text-center">
                  <div className="a-loading a-primary a-m-10">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            ) : 
            <form onSubmit={handleSubmit}>
              <div className="row ">
                <div className="col-md-12">
                  <div className="row ">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label htmlFor="AssessmentIDEditVendor" className="cv-input-label">
                          Assessment ID <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          type="text"
                          id="AssessmentIDEditVendor"
                          value={values.assessmentID}
                          name="assessmentID"
                          placeholder="Please enter Assessment ID"
                          disabled
                        />
                      </div>
                      
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label className="cv-input-label">
                          Third Party Name <span className="asterisk-required">*</span>
                        </label>
                        <Select
                          className="cv-input-field"
                          dropdownRenderMode="portal"
                          type="email"
                          data={vendors}
                          labelKey="vendor_name"
                          valueKey="vendor_id"
                          value={values.vendorName}
                          name="assessment"
                          placeholder="Select third party name"
                          disabled
                        ></Select>
                      </div>
                     
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label htmlFor="scopeEditVendor" className="cv-input-label">
                          Scope of Assessment{" "}
                          <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          id="scopeEditVendor"
                          type="text"
                          value={values.scopeOfAssessment}
                          name="scope Of Assessment"
                          placeholder="Please enter scope of assessment"
                          disabled
                        />
                      </div>
                      
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label className="cv-input-label">
                          Third Party Manager <span className="asterisk-required">*</span>
                        </label>
                        <Select
                          className="cv-input-field"
                          dropdownRenderMode="portal"
                          type="email"
                          value={values.manager}
                          data={manager}
                          valueKey="user_id"
                          labelKey="user_name"
                          name="assessment"
                          placeholder="Select Manager"
                          disabled
                        ></Select>
                      </div>
                      
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label htmlFor="respondentEditVendor" className="cv-input-label">
                          Third Party respondent{" "}
                          <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          id="respondentEditVendor"
                          type="text"
                          value={values.respondent}
                          name="respondent"
                          placeholder="Please enter third party respondent"
                        //disabled
                        />
                      </div>
                      
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label className="cv-input-label">
                          Work Program{" "}
                          <span className="asterisk-required">*</span>
                        </label>
                        <Select
                          showSearchOnToggle={true}
                          dropdownRenderMode="portal"
                          className="cv-input-field"
                          data={workProgramName}
                          valueKey="workprogram_id"
                          labelKey="work_program_name"
                          value={values.workProgram}
                          name="Third Party Name"
                          placeholder="Select work program Name"
                          disabled
                        ></Select>
                      </div>
                      
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label htmlFor="assessorEditVendor" className="cv-input-label">
                          Assessor Comment{" "}
                          <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          id="assessorEditVendor"
                          onBlur={handleBlur}
                          type="text"
                          value={values.assesorComment}
                          name="respondent"
                          placeholder="Please enter assessor comment"
                          disabled
                        />
                      </div>
                     
                    </div>
                   
                    </div>
                    <div className="row mt-3">
                    <div className="col-sm-12">
                    <div className="col-sm-1 noteFontSize">
                    Note :
                      </div>
                      <div className="col-sm-10 noteFontSizeMargin">
                      To mark your responses, upload evidence and add additional comments for respective questions, double-click on the relevant cells under "Third party response", "Evidence",<br/> "Third party comments" columns of the assessment. <br/>
                      Evidence document file size should be less than 20 MB. Allowed file types are pdf, csv, excel, power-point, txt, png, jpg, jpeg.
                      </div>
                    
                      </div>
                     
                    </div>
                </div>
              </div>

              <div className="row  pl-3">
                <div className="col-lg-12 mt-3 pl-1">
                <div class="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                          <AgGridReact
                            rowData={tableData && tableData}
                            columnDefs={ selectedType === 1?colDefs1:colDefs2}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            onGridReady={onGridReady}
                            onCellValueChanged={onCellValueChanged}
                            rowStyle={rowStyle}
                            defaultColGroupDef={defaultColGroupDef}
                          />
                        </div>
                </div>
              </div>
              <div className="row m-0">
                <div className="col-sm-6 mt-3">
                  <div className="">
                    <label htmlFor="Comments" className="cv-input-label">
                      Comments <span className="asterisk-required"></span>
                    </label>
                    <TextArea
                      className="cv-input-field input-field-border"
                      type="text"
                      value={comments}
                      onChange={handleChangeComment}
                      name="comments"
                      title="Add your comments."
                    />
                    {commentsFormat && (
                      <label className="requiredComments">
                        Only alphabets and some special characters are allowed
                        for this field
                      </label>
                    )}
                  </div>
                </div>
              </div>

              <div className="options-container">
                <button
                   disabled={isSubmitting}
                    type="button"
                  className="save-button me-4"
                  onClick={() => saveHandler("submit")}
                >
                  Submit
                </button>
                <button
                 disabled={isSubmitting}
                    type="button"
                  className="save-button me-4"
                  // onClick={saveHandler}
                  onClick={() => saveHandler("save")}
                >
                  Save
                </button>
                <button
                  className="cancel-button"
                  type="reset"
                  onClick={props.sendBack}
                >
                  Cancel
                </button>
              </div>
            </form>
          );
        }}
      </Formik>
      }
      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={modalVisible}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
          modalStyle={{ width: "49.75rem", maxHeight: "fit-content" }}
        >
          <div className="modal-title">
            {`Are you sure you want to ${paramStatus} the assessment?`
             }
          </div>
          <ModalFooter>
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
            >
              No
            </button>
            <button
              type="submit"
              className="save-button m-l-2"
              onClick={handleConfirm}
            >
              Yes
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

EditVendor.propTypes = {
  getAllInitialData: PropTypes.func,
  SelfAssessmentData: PropTypes.array,
  sendBack: PropTypes.func,
  tableDataProp: PropTypes.array,
  wpCategoryData: PropTypes.array
}

